import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';

import { log } from './log';
import { isAndroid } from './platform';

import type { URLOpenListenerEvent } from '@capacitor/app';
export const openAndWaitForCallback = async (url: string): Promise<URLOpenListenerEvent> => {
  // waiting for possible previous in-app browser to actually close
  log.trace(`Opening ${url} in 300ms.`);
  await delay(300);

  // do NOT wait for the browser to open, so that the app listener will be listening already when the browser is opened
  Browser.open({ url });

  log.trace('Waiting for callback');
  const urlOpenListenerEvent = await waitForCallback();

  log.trace('Callback from in-app browser detected.', urlOpenListenerEvent.url);

  if (!isAndroid()) {
    await Browser.close();
  }

  return urlOpenListenerEvent;
};

const delay = (timeout: number) => new Promise(resolve => setTimeout(resolve, timeout));

const waitForCallback = (): Promise<URLOpenListenerEvent> => {
  return new Promise(resolve => {
    const appListener = App.addListener('appUrlOpen', async event => {
      log.trace('Callback from in-app browser detected. Removing app listener.');
      const listener = await appListener;
      listener.remove();
      resolve(event);
    });
  });
};
